var safeEscape = function safeEscape(callbackFunction) {
  var shouldFire = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (event) {
    if (shouldFire && !event.haltCanvasEvent) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        event.stopPropagation();
        event.haltCanvasEvent = true;
        callbackFunction(event);
      }
    }
  };
};

export { safeEscape as default };
